import React, { useEffect } from 'react';
import { HeroSectionCanino456 } from '../components/landing/HeroSectionCanino456';
import { PatternSection } from '../components/landing/PatternSection';
import { ProblemSection } from '../components/landing/ProblemSection';
import { SolutionSection } from '../components/landing/SolutionSection';
import { BenefitsSectionWithCheckout } from '../components/landing/BenefitsSectionWithCheckout';
import { FAQSection } from '../components/landing/FAQSection';
import { CTASectionWithCheckout } from '../components/landing/CTASectionWithCheckout';
import { PurchaseNotifier } from '../components/PurchaseNotifier';
import { ConsequencesSection, ProtocolIntroSection, ProgramIncludesSection, AuthorSection, WrittenTestimonialsSection } from '../components/landing/FunnelSections';
export function LandingPageCanino5() {
  useEffect(() => {
    document.title = '30 Recetas Naturales para Perros';
  }, []);
  const checkoutUrl = 'https://pay.hotmart.com/Y104256235W?off=mstmo7g1&checkoutMode=10&bid=1773273486617';
  return <main className="min-h-screen bg-gradient-to-b from-orange-50/20 to-yellow-50/20 font-sans text-gray-900" data-id="element-1779">
      <HeroSectionCanino456 data-id="element-1780" />
      <PatternSection hideAudio data-id="element-1781" />
      <ConsequencesSection showCTA data-id="element-1782" />
      <ProtocolIntroSection data-id="element-1783" />
      <ProgramIncludesSection showCTA data-id="element-1784" />
      <AuthorSection data-id="element-1785" />
      <WrittenTestimonialsSection data-id="element-1786" />
      <BenefitsSectionWithCheckout checkoutUrl={checkoutUrl} displayPrice="$69.999" data-id="element-1787" />
      <ProblemSection data-id="element-1788" />
      <SolutionSection data-id="element-1789" />
      <FAQSection data-id="element-1790" />
      <CTASectionWithCheckout checkoutUrl={checkoutUrl} displayPrice="$69.999" data-id="element-1791" />
      <footer className="bg-orange-50/30 py-12 border-t border-orange-100" data-id="element-1792">
        <div className="container mx-auto px-4 text-center" data-id="element-1793">
          <p className="text-gray-500 text-sm" data-id="element-1794">
            © {new Date().getFullYear()} Recetas Anti-Inflamación para Perros.
            Todos los derechos reservados.
          </p>
          <p className="text-gray-400 text-xs mt-2" data-id="element-1795">
            Este producto es una guía educativa y no sustituye el consejo
            veterinario profesional.
          </p>
        </div>
      </footer>
      <PurchaseNotifier enabled={true} displayPrice="$69.999 COP" data-id="element-1796" />
    </main>;
}